module.exports = __webpack_public_path__ + "static/media/logo_p_picktow.8590fe5f.svg";